import React from 'react';
import PropTypes from 'prop-types';
import WeatherLocation from './WeatherLocation';

    
// const LocationList = ({ cities })  => (
//     <div>
//         <WeatherLocation city={'Santiago,scl'} />
//         <WeatherLocation city={'Bogota,col'} />
//         <WeatherLocation city={'Buenos Aires,ar'} />
//         <WeatherLocation city={'Rio de janeiro,br'} />

//     </div>


// );

const LocationList = ({ cities, onSelectedLocation }) => {
    const hadlerWeatherLocationClick = city => {
        console.log('hadlerWeatherLocationClick');
        onSelectedLocation(city);
        
    }

const strToComponent = cities => (
    cities.map(city => (
    <WeatherLocation 
    key={city} 
    city={city}
    onWeatherLocationClick={() =>
            hadlerWeatherLocationClick(city)}/>))        
);
return (
    <div>
        {strToComponent(cities)}

    </div>
    )
};


LocationList.propTypes = {
    cities: PropTypes.array.isRequired,
}

export default LocationList;


// WEBPACK FOOTER //
// ./src/components/LocationList.js